import SEOHead from '@/components/feature/SEOHead';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import Mission from './components/Mission';
import Values from './components/Values';
import Team from './components/Team';
import Timeline from './components/Timeline';
import Culture from './components/Culture';
import AboutCTA from './components/AboutCTA';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '픽스코프 소개 | Fixcope About',
  url: `${siteUrl}/about`,
  description: '픽스코프의 미션, 비전, 핵심 가치와 팀을 소개합니다. 기술과 신뢰로 글로벌 시장을 연결하는 솔루션 파트너입니다.',
  inLanguage: 'ko-KR',
  mainEntity: {
    '@type': 'Organization',
    name: 'Fixcope',
    url: siteUrl,
  },
};

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="픽스코프 소개 | Fixcope - 미션·비전·팀 소개"
        description="픽스코프의 미션, 비전, 핵심 가치와 팀을 소개합니다. 기술과 신뢰로 글로벌 시장을 연결하는 솔루션 파트너 픽스코프를 만나보세요."
        keywords="픽스코프 소개, Fixcope about, 회사 소개, 미션, 비전, 글로벌 솔루션"
        canonical="/about"
        ogTitle="픽스코프 소개 | Fixcope"
        ogDescription="기술과 신뢰로 글로벌 시장을 연결하는 픽스코프의 미션과 팀을 소개합니다."
        lang="ko"
        jsonLd={aboutJsonLd}
      />
      <Navbar />
      <AboutHero />
      <Mission />
      <Values />
      <Team />
      <Timeline />
      <Culture />
      <AboutCTA />
      <Footer />
    </div>
  );
}
